import React, { FC } from 'react';
import classNames from 'classnames';

import QuillEditor from '../QuillEditor';

import { NotesProps } from './interfaces';

import useStyles from './style';

const Notes: FC<NotesProps> = ({
  onChange,
  placeholder,
  className,
  autoFocus,
  initialValue = '',
}) => {
  const classes = useStyles();

  return (
    <QuillEditor
      value={initialValue}
      onChange={onChange}
      placeholder={placeholder}
      wrapperClassName={classNames(classes.editor, className)}
      toolbarId="notes-toolbar"
      autoFocus={autoFocus}
    />
  );
};

export default Notes;
